/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

import { getAverage, getTrend } from '../util';
import FormLine from './FormLine';
import QuickStats from './QuickStats';

interface Props {
  isSmall?: boolean;
  player: *;
}

const Form = ({ isSmall = false, player }: Props) => {
  return (
    <Wrapper>
      <QuickStats
        averageScore={player.averageScore}
        highScore={player.highScore}
        maxScore={player.maxScore}
        mediumTermAverage={getAverage(player.games, 6)}
        mediumTermTrend={getTrend(player.games, 6)}
        shortTermAverage={getAverage(player.games, 3)}
        shortTermTrend={getTrend(player.games, 3)}
        isSmall={isSmall}
      />
      <FormLine
        games={player.games}
        maxScore={player.maxScore}
        name={player.name}
        isSmall={isSmall}
      />
    </Wrapper>
  );
};

export default Form;

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  color: theme.color.basis4,
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
}));
